import { Injectable } from "@angular/core";
import {
  CanLoad,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  Route,
  UrlSegment,
  ActivatedRoute,
} from "@angular/router";
import { Observable } from "rxjs";
import { CoginitoIdentityDataService } from "../coginito-identity-data/coginito-identity-data.service";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class SkipRegisterGuard implements CanLoad {
  public url_parameters: Object = {};
  public isCampaignURL: boolean = false;
  public isB2CLead: boolean = false;

  constructor(
    private coginitoIdentityDataService: CoginitoIdentityDataService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.coginitoIdentityDataService.getAuthToken()) {
      return true;
    } else {

      this.route.queryParams.subscribe((params) => {
        if(!localStorage.getItem('isPayLater') && !localStorage.getItem('isTermLoans') ) {
          let urlLocation = JSON.parse(JSON.stringify(location));
        let urlSearch = urlLocation.search;
        console.log(urlSearch, urlLocation, location);
        urlSearch = urlSearch.substr(1, urlSearch.length);
        urlSearch = urlSearch.split("&");
        urlSearch.forEach((prop) => {
          let keyValuePair = prop.split("=");
          this.url_parameters[keyValuePair[0]] = keyValuePair[1];
        });
        if (this.url_parameters["campaign"] && environment.production) {
          localStorage.setItem("campaign", this.url_parameters["campaign"]);
        } else if (
          this.url_parameters["utm_source"] &&
          environment.production
        ) {
          localStorage.setItem("campaign", this.url_parameters["utm_source"]);
          this.isCampaignURL = true;
        } else if (this.url_parameters["B2C"]) {
          localStorage.setItem("campaign", "b2c");
          this.isB2CLead = true;
        }
        if (environment.production && this.isCampaignURL) {
          const script1 = document.createElement("script");
          script1.async = true;
          script1.src =
            "https://www.googletagmanager.com/gtag/js?id=" + environment.code;

          var script = document.createElement("script");
          script.type = "text/javascript";
          script.innerHTML = `window.dataLayer = window.dataLayer || [];
                         function gtag() { dataLayer.push(arguments); }
                         gtag('js', new Date());
                         gtag('config', 'UA-143351251-4');`;
          document.head.prepend(script);
        }
        }
        this.router.navigate(["/dashboard"]);
        return false;
      });
    }
  }
}
